module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "d7e94"
    }
  }, [_c('h1', {
    staticClass: "chapno"
  }), _c('h2', {
    staticClass: "chapttl",
    attrs: {
      "id": "d7e95"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e98"
    }
  }, [_vm._v("So many people helped make this book a reality, and we would like to extend our profound and sincere gratitude to each of them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e100"
    }
  }, [_vm._v("The following people are key contributors to both AskDan "), _c('a', {
    attrs: {
      "href": "http://AndJennifer.com",
      "target": "_blank"
    }
  }, [_vm._v("AndJennifer.com")]), _vm._v(" and this book. Their knowledge, skills, and wisdom help us all.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e105"
    }
  }, [_vm._v("Kaylen Shubrick, our amazing writer and editor who helps turn our thoughts and videos into words.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e107"
    }
  }, [_vm._v("Paul Carlson ("), _c('i', [_c('a', {
    attrs: {
      "href": "http://www.PersonalChanges.com",
      "target": "_blank"
    }
  }, [_vm._v("www.PersonalChanges.com")])]), _vm._v("), life coach and CCHt (Certified Clinical Hypnotherapist). His background provides him with a unique ability to provide guidance and coaching for those who want a better, happier, and more successful personal and business life.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e113"
    }
  }, [_vm._v("Melody Brooke ("), _c('i', [_c('a', {
    attrs: {
      "href": "http://www.ThisIsGreatSex.com",
      "target": "_blank"
    }
  }, [_vm._v("www.ThisIsGreatSex.com")])]), _vm._v("), Professional and Marriage and Family Counselor, international speaker, author, and founder of "), _c('a', {
    attrs: {
      "href": "http://ThisIsGreatSex.com",
      "target": "_blank"
    }
  }, [_vm._v("ThisIsGreatSex.com")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e122"
    }
  }, [_vm._v("The Beautiful Kind ("), _c('i', [_c('a', {
    attrs: {
      "href": "http://www.TheBeautifulKind.com",
      "target": "_blank"
    }
  }, [_vm._v("www.TheBeautifulKind.com")])]), _vm._v("), kink expert, sex writer, and consultant, as well as a sex worker specializing in fetishes and surrogacy (a sexual surrogate is someone who helps others overcome social and sexual issues through hands-on intimacy).")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e128"
    }
  }, [_vm._v("In addition, we would like to thank the following people for making this book possible:")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e130"
    }
  }, [_vm._v("Neil Salkind ("), _c('i', [_c('a', {
    attrs: {
      "href": "http://www.studiob.com/salkindagency",
      "target": "_blank"
    }
  }, [_vm._v("www.studiob.com/salkindagency")])]), _vm._v("), our amazing literary agent; and all of the amazing people at Adams Media ("), _c('i', [_c('a', {
    attrs: {
      "href": "http://www.adamsmedia.com",
      "target": "_blank"
    }
  }, [_vm._v("www.adamsmedia.com")])]), _vm._v("), our publisher, for their incredible help and support while writing this book.")]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e140"
    }
  }, [_vm._v("And last, but not least, we extend our profound thanks to you for reading this book. We hope you have as much fun reading it as we did writing it!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4926d12c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_9781440506963_epub_ack.vue
// module id = 69
// module chunks = 0